export default __webpack_public_path__ + "static/media/portadaLogin.306ca66a.jpg";